import { types, actions } from './requests'
export const GETTURNLIST_TYPES = {
    ...types('GETTURNLIST'),
}
export const GETTURNLIST_ACTIONS = {
    ...actions('GETTURNLIST'),
}
